import { useGetProjectOverview } from '@/shared/hooks/projects/useGetProjectOverview'
import TabLayout from '@/shared/layouts/TabLayout'
import { createFileRoute, Outlet, useNavigate } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

export const Route = createFileRoute('/projects/$id/_pathlessLayout')({
    component: RouteComponent,
})

function RouteComponent() {
    const { id } = Route.useParams()
    const { t } = useTranslation()
    const { data: overview } = useGetProjectOverview(id)
    const data = overview?.project
    const navigate = useNavigate()

    return (
        <TabLayout
            title={(data as any)?.name}
            showBackButton={true}
            onBack={() => {
                if (window.history.length > 2) {
                    window.history.back()
                } else {
                    navigate({ to: '/projects' })
                }
            }}
            linksTo={[
                { to: `/projects/${id}`, label: t('projects.detail.tabs.info') },
                { to: `/projects/${id}/project-profile`, label: t('projects.detail.tabs.documents') },
                { to: `/projects/${id}/tasks`, label: t('projects.detail.tabs.tasks') },
                { to: `/projects/${id}/permissions`, label: t('projects.detail.tabs.permissions') },
            ]}
        >
            <Outlet />
        </TabLayout>
    )
}
